import { render, staticRenderFns } from "./SendCampaign.vue?vue&type=template&id=5056ec78&"
import script from "./SendCampaign.vue?vue&type=script&lang=js&"
export * from "./SendCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports